import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import type { ComponentType } from 'react';
import { useCallback } from 'react';
import { z } from 'zod';
import { type FilterProps, createFilterDefHelper, useComposableFilter } from '@/components/ComposableFilter';
import { SoftwareFilterChip } from '@/components/FilterChip';
import { usePaginationSearch } from '@/lib/listPage';
import { AllDealTable } from './-components/AllDealTable';
import { AllSearchFilterBar } from './-components/AllSearchFilterBar';
import { useAllDealList } from './-query';
const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  softwareIds: z.array(z.string()).optional()
});
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/')({
  component: AllTab,
  validateSearch: zodValidator(SearchSchema)
});
type AllFilter = {
  softwareIds: string[] | undefined;
};
const helper = createFilterDefHelper<AllFilter>();
type FilterComponent = ComponentType<FilterProps<string[] | undefined>>;
function AllTab() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const [pagination, setPagination] = usePaginationSearch({
    search,
    onSearchChange: s => navigate({
      search: s
    })
  });
  const {
    data,
    isPending
  } = useAllDealList({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    freeText: search.freeText,
    softwareIds: search.softwareIds
  });
  const filterState: AllFilter = {
    softwareIds: search.softwareIds
  };
  const filterDefs = [helper('softwareIds', {
    component: SoftwareFilterChip as FilterComponent
  })];
  const filter = useComposableFilter<AllFilter>({
    filterDefs,
    filterState,
    onFilterStateChange: useCallback((state: AllFilter | ((prev: AllFilter) => AllFilter)) => {
      navigate({
        search: prev => {
          const currentFilter: AllFilter = {
            softwareIds: prev.softwareIds
          };
          const resolved = typeof state === 'function' ? state(currentFilter) : state;
          return {
            ...prev,
            softwareIds: resolved.softwareIds,
            pageIndex: 0
          };
        }
      });
    }, [navigate])
  });
  return <>
      <AllSearchFilterBar searchValue={search.freeText ?? ''} onSearchChange={e => navigate({
      search: prev => ({
        ...prev,
        freeText: e.target.value || undefined,
        pageIndex: 0
      })
    })} filter={filter} />
      <AllDealTable data={data?.items ?? []} isPending={isPending} totalCount={data?.count} pageCount={data?.maxPage} pagination={pagination} onPaginationChange={setPagination} className="flex-1 min-h-0" />
    </>;
}